import initAmplitude from './amplitude'
import initConsole from './console'
import { initMetabase } from './metabase'
import initPosthog from './posthog'
import type { InitConfig, Tracker } from './types'
import { getShouldPrintEvents } from './utils'

export * from './types'
const isProd = import.meta.env.PROD

let trackers: Tracker[] = []

export function init(config: InitConfig): void {
  trackers = []

  // Init Amplitude
  if (config.amplitude && isProd) {
    const amplitudeTracker = initAmplitude(config.amplitude)
    if (amplitudeTracker) trackers.push(amplitudeTracker)
  }
  if (isProd) {
    const metabaseTracker = initMetabase()
    trackers.push(metabaseTracker)
  }
  // Init PostHog
  if (config.posthog && isProd) {
    const posthogTracker = initPosthog(config.posthog)
    if (posthogTracker) trackers.push(posthogTracker)
  }
  // Init Console logger
  const shouldPrintEvents = getShouldPrintEvents()
  if (shouldPrintEvents || config.debug === true) {
    const consoleLogger = initConsole()
    trackers.push(consoleLogger)
  }
}

function apply<Key extends keyof Tracker>(key: Key): Tracker[Key] {
  // oxlint-disable-next-line typescript/no-explicit-any
  return (...args: any[]) => {
    trackers.forEach((tracker) => {
      // oxlint-disable-next-line typescript/no-explicit-any
      const fn = tracker[key] as (...args: any[]) => void
      fn(...args)
    })
  }
}

const tracker: Tracker = {
  event: apply('event'),
  identify: apply('identify'),
  modalview: apply('modalview'),
  pageview: apply('pageview'),
  reset: apply('reset'),
  record: apply('record'),
}

export default tracker
